import { render, staticRenderFns } from "./Org.vue?vue&type=template&id=3e161fea&scoped=true&"
import script from "./Org.vue?vue&type=script&lang=ts&"
export * from "./Org.vue?vue&type=script&lang=ts&"
import style0 from "./Org.vue?vue&type=style&index=0&id=3e161fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e161fea",
  null
  
)

export default component.exports